import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { loanPrograms } from "../../mock";
import Reveal from "../Reveal";

export default function LoanProgramsSection() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">Most Popular</p>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0b1f3a] mt-3">
            Business Financing Solutions
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Customized to your unique needs — explore our range of commercial loan programs built
            for investors and business owners.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-7 sm:grid-cols-2 lg:grid-cols-4">
          {loanPrograms.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 4) * 90}>
              <Link
                to={`/loan-programs/${p.slug}`}
                className="group block h-full rounded-2xl bg-white overflow-hidden ring-1 ring-slate-100 shadow-sm hover:shadow-2xl hover:-translate-y-1.5 transition-all duration-300"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0b1f3a]/70 to-transparent" />
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-lg text-[#0b1f3a] group-hover:text-[#b08e46] transition-colors">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed line-clamp-3">{p.short}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#c6a15b]">
                    Learn More
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/loan-programs"
            className="inline-flex items-center gap-2 rounded-md bg-[#0b1f3a] px-7 py-3.5 font-bold text-white hover:bg-[#13294b] transition-colors"
          >
            View All Loan Programs
            <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
